module.exports = "./img/cf4b31baa1b4474320f4dc747983b9f4.jpg";